<template>
  <Sider
    :collapsed="getCollapsed"
    collapsible
    :trigger="null"
    theme="light"
    class="layout-sider"
    collapsedWidth="48"
  >
    <AppLog />
    <Menu />
  </Sider>
</template>
<script lang="ts" setup>
import { Layout } from "ant-design-vue";
import Menu from "../menu/index.vue";
import AppLog from "./components/appLog.vue";
const { Sider } = Layout;
console.log(Menu);

import { useMenuSetting } from "/@/hooks/setting/useMenuSetting";
const { getCollapsed } = useMenuSetting();
</script>
<style lang="less" scoped>
.layout-sider {
  overflow: auto;
  height: 100vh;
  left: 0;
}
</style>
